<div class="search-grp" *ngIf="searchOptions">
	<div class="search-grp__input-wrapper">
		<lu-icon class="search-grp__ico" icon="lu-search"></lu-icon>
		<label [for]="uniqueId" class="sr-only">{{
			searchOptions.label || searchOptions.placeHolder || ('search' | translate)
		}}</label>
		<input
			#search
			[id]="uniqueId"
			[(ngModel)]="value"
			type="search"
			class="search-grp__control"
			autocomplete="off"
			[attr.aria-label]="'lup.select.search_guidance' | translate"
			(keyup)="searchValue = search.value; valueChange.emit({ value: searchValue, event: $event })"
			(keyup.enter)="triggerSearch.emit({ value: searchValue, event: $event })"
			[placeholder]="searchOptions.placeHolder || ('search' | translate)"
			(click)="inputClicked.emit()" />
		<button
			class="btn btn--ico search-grp__clear-search"
			*ngIf="!!searchValue && searchValue.length > 0"
			[title]="'lup.a11y.clear_search' | translate"
			[attr.aria-label]="'lup.a11y.clear_search' | translate"
			(click)="onClearSearch(search, $event)">
			<lu-icon icon="times"></lu-icon>
		</button>
	</div>
</div>
